import { getObservablePluginLinks } from '@grafana/runtime';
import { map, Observable, of } from 'rxjs';

export const ASSISTANT_PLUGIN_ID = 'grafana-assistant-app';
export const ASSISTANT_PLUGIN_TITLE = 'Grafana Assistant';

/**
 * Check if the assistant is available.
 * @returns An observable that emits true if the assistant is available, false otherwise.
 */
export function isAssistantAvailable(): Observable<boolean> {
  // this is to avoid crashing in older Grafana versions
  if (!getObservablePluginLinks) {
    return of(false);
  }

  const links = getObservablePluginLinks({
    extensionPointId: 'grafana/extension-sidebar/v0-alpha',
  });
  const isAssistantAvailable = links.pipe(
    map((links: Array<{ pluginId: string; title: string }>) =>
      links.some((link) => link.pluginId === ASSISTANT_PLUGIN_ID && link.title === ASSISTANT_PLUGIN_TITLE)
    )
  );
  return isAssistantAvailable;
}
